import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
  StyledBoxContent,
  StyledBoxDown,
  StyledButton,
  StyledButtonPlus
} from './style';

import VolunteerItem from './VolunteerItem';
import Modal from '../../../core/Modal';
import { VOLUNTEER } from '../../../../constants/literals/modals';
import { moveElementPosition } from '../../../../utils/splices';

class Volunteer extends Component {
  constructor(props) {
    super(props);

    const data = props.dataVolunteer.map(item => ({
      ...item,
      errorOrganization: false,
      errorRole: false
    }));

    this.state = {
      data,
      dataVolunteerFormatted: data,
      btnIsDisabled: true
    };
  }

  componentDidMount() {
    const { data } = this.state;

    if (data.length === 0) {
      this.handlePlus();
    }
  }

  onClickDelete = index => {
    const { data } = this.state;
    const updatedData = data.filter((ele, i) => i !== index);

    this.setState({
      data: updatedData,
      btnIsDisabled: this.getBtnStatus(updatedData)
    });
  };

  onClickOrderArrow = (index, isDown) => {
    const { data } = this.state;
    const move = isDown ? index + 1 : index - 1;
    const updatedData = moveElementPosition([...data], index, move);

    this.setState({
      data: updatedData,
      btnIsDisabled: this.getBtnStatus(updatedData)
    });
  };

  getBtnStatus = data => {
    const { dataVolunteerFormatted } = this.state;

    return _.isEqual(dataVolunteerFormatted, data);
  };

  validateFields = () => {
    const { data } = this.state;

    for (const ele in data) {
      if (!data[ele].organization || !data[ele].role) {
        return true;
      }
    }

    return false;
  };

  handleAccept = () => {
    const { onAcceptModal } = this.props;
    const { data } = this.state;

    const error = this.validateFields();

    if (error) {
      this.setState({
        data: data.map(item => ({
          ...item,
          errorOrganization: !item.organization,
          errorRole: !item.role
        }))
      });
    } else {
      onAcceptModal(
        data.map(item => ({
          organization: item.organization,
          role: item.role
        }))
      );
    }
  };

  handleChange = (value, index, key) => {
    const { data } = this.state;
    const clonedData = [...data];

    clonedData[index] = { ...clonedData[index], [key]: value };

    this.setState({
      data: clonedData,
      btnIsDisabled: this.getBtnStatus(clonedData)
    });
  };

  handlePlus = () => {
    const { data } = this.state;
    const clonedData = [...data];

    clonedData.push({
      organization: '',
      role: '',
      errorOrganization: false,
      errorRole: false
    });

    this.setState({
      data: clonedData,
      btnIsDisabled: this.getBtnStatus(clonedData)
    });
  };

  render() {
    const { onCloseModal } = this.props;
    const { data, btnIsDisabled } = this.state;
    return (
      <Modal title={VOLUNTEER.TITLE} clickCloseIcon={onCloseModal}>
        <StyledBoxContent>
          {data.map((item, index) => (
            <VolunteerItem
              key={`volunteer${index + 1}`}
              onChangeInputOrganization={e =>
                this.handleChange(e, index, 'organization')
              }
              onChangeInputRole={e => this.handleChange(e, index, 'role')}
              onClickDelete={() => this.onClickDelete(index)}
              onClickDown={() => this.onClickOrderArrow(index, true)}
              onClickUp={() => this.onClickOrderArrow(index, false)}
              order={index + 1}
              organization={item.organization}
              role={item.role}
              errorOrganization={item.errorOrganization}
              errorRole={item.errorRole}
            />
          ))}
          <StyledButtonPlus onClick={this.handlePlus} dark />
          <StyledBoxDown>
            <StyledButton onClick={onCloseModal} modal>
              {VOLUNTEER.CANCEL}
            </StyledButton>
            <StyledButton
              onClick={this.handleAccept}
              secondary
              disabled={btnIsDisabled}
            >
              {VOLUNTEER.ACCEPT}
            </StyledButton>
          </StyledBoxDown>
        </StyledBoxContent>
      </Modal>
    );
  }
}

Volunteer.propTypes = {
  dataVolunteer: PropTypes.arrayOf(
    PropTypes.shape({
      organization: PropTypes.string,
      role: PropTypes.string
    })
  ),
  onAcceptModal: PropTypes.func,
  onCloseModal: PropTypes.func
};

Volunteer.defaultProps = {
  dataVolunteer: []
};

export default Volunteer;
